import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../store/auth.js"
export default function PrivateRoute() {
  const token = useAuth((state) => state.token);
  const userId = useAuth((state) => state.userId);
  return token !== "" && userId !== 0 ? <Outlet /> : <Navigate to="/generateOTP" />;
}
